(function () {
  document.querySelectorAll('[data-problem-solver]').forEach((solver) => {
    const picker = solver.querySelector('[data-problem-picker]');
    const cards = [...solver.querySelectorAll('[data-problem-result]')];
    if (!picker || !cards.length) return;
    const render = () => {
      const value = picker.value;
      cards.forEach((card) => { card.hidden = Boolean(value) && card.dataset.problemResult !== value; });
    };
    picker.addEventListener('change', render);
    render();
  });

  document.querySelectorAll('[data-checklist]').forEach((checklist) => {
    const key = `cleankompas-checklist:${checklist.dataset.checklist}`;
    const boxes = [...checklist.querySelectorAll('input[type="checkbox"]')];
    try {
      const stored = JSON.parse(localStorage.getItem(key) || '[]');
      boxes.forEach((box) => { box.checked = stored.includes(box.value); });
    } catch {}
    checklist.addEventListener('change', () => {
      try { localStorage.setItem(key, JSON.stringify(boxes.filter((box) => box.checked).map((box) => box.value))); } catch {}
    });
    checklist.querySelector('[data-checklist-reset]')?.addEventListener('click', () => {
      boxes.forEach((box) => { box.checked = false; });
      try { localStorage.removeItem(key); } catch {}
    });
  });

  document.querySelectorAll('[data-print-page]').forEach((button) => button.addEventListener('click', () => window.print()));

  document.querySelectorAll('[data-article-feedback]').forEach((widget) => {
    const handle = widget.dataset.articleHandle || 'article';
    const storageKey = `cleankompas-feedback:${handle}`;
    const buttons = [...widget.querySelectorAll('[data-feedback-value]')];
    const status = widget.querySelector('[data-feedback-status]');
    let completed = false;
    try { completed = Boolean(localStorage.getItem(storageKey)); } catch {}
    if (completed) {
      buttons.forEach((button) => { button.disabled = true; });
      if (status) status.textContent = 'Bedankt, je reactie is al bewaard.';
    }
    buttons.forEach((button) => button.addEventListener('click', () => {
      if (completed) return;
      completed = true;
      const response = button.dataset.feedbackValue;
      buttons.forEach((item) => { item.disabled = true; });
      if (status) status.textContent = response === 'yes' ? 'Bedankt. Fijn dat de uitleg hielp.' : 'Bedankt. We gebruiken dit signaal om de uitleg te verbeteren.';
      try { localStorage.setItem(storageKey, response); } catch {}
      const privacy = window.Shopify?.customerPrivacy;
      if (privacy?.analyticsProcessingAllowed?.() === true && window.Shopify?.analytics?.publish) {
        window.Shopify.analytics.publish('cleankompas:article_feedback', { response, article_handle: handle });
      }
    }));
  });
})();
